import React, { useEffect } from "react";
import { aboutMeType } from "../../../../common/interfaces/myProfile/personalDetails/aboutMeType";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValues {
  setAboutMeData: (data: aboutMeType) => void;
}

function DTOPersonalInfo({ setAboutMeData }: PropsValues) {
  const aboutMe_data = useAppSelector((state) => state.aboutMeSlice.about_me);

  useEffect(() => {
    const aboutMe: aboutMeType = {
      about_me: aboutMe_data,
    };
    setAboutMeData(aboutMe);
  }, [aboutMe_data]);

  return <></>;
}
export default DTOPersonalInfo;
